export default __webpack_public_path__ + "static/media/contact.c2b2bbe6.png";